export default __webpack_public_path__ + "static/media/arcos1_g.dab9adbc.jpg";